var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview",staticStyle:{"weight":"100%"}},_vm._l((_vm.mensagens),function(msg,key){return _c('div',{key:key,staticClass:"w-100 d-flex mb-3",class:{
      'justify-content-end': msg.fromMe,
      'justify-content-start': !msg.fromMe
    }},[_c('div',{staticClass:"message",class:{ 'from-me': msg.fromMe, 'from-them': !msg.fromMe }},[_c('div',{staticStyle:{"padding":"7px 7px 6px 9px"},domProps:{"innerHTML":_vm._s(_vm.formatTextToHTML(msg.text))}})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }